export const environment = {
    production: true,
    constructorHref: '/websites/builder/',
    fileManagerCdnUrl: 'https://cdn.wdgtsrc.com',
    memberAreaUrl: 'https://login.sendpulse.com',
    proxyUrl: '/sp-auth',
    eduStudentUrl: '/courses',
    landingPagesHref: '/landing-pages/',
    type: 'prod',
};
